export function getGroupValue(group) {
  if (group.hasOwnProperty('polarity')) {
    return group.polarity === 1 ? group.value : -group.value;
  }

  return group.value;
}
